import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCheckbox, CustomModal, InputText } from '../../../../components'
import * as OcorrenciaHttp from '../../../../services/api/https/picking/ocorrencia.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_REASON: 'Salvando ocorrência',
  SUCCESS: 'Ocorrência salva com sucesso',
}

const INITIAL_STATE = {
  ocorrencia: {
    id: '',
    company_id: '',
    sigla: '',
    company_code: null,
    descricao: '',
    assoc_guilty_client: false,
    actived: false,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function ModalOcorrenciaEntrega({ dispatch, show, onModalClose, onModalSave, data }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (data) {
      setState(prevState => ({
        ...prevState,
        ocorrencia: { ...INITIAL_STATE.ocorrencia, ...data },
      }))
    }
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE_REASON:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        saveOcorrencia(state.ocorrencia)
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        onModalSave(state.ocorrencia)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const saveOcorrencia = ocorrencia => {
    OcorrenciaHttp.saveOcorrencia(ocorrencia)
      .then(ocorrencia =>
        setState(prevState => ({
          ...prevState,
          ocorrencia: ocorrencia,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: errorHandler(err),
        })),
      )
  }

  const onFormContentChange = (name, value) => {
    setState(prevState => {
      prevState.ocorrencia[name] = value
      return { ...prevState }
    })
  }

  const onBtnSalvarClicked = async () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_REASON }))
  }

  return (
    <CustomModal header="Ocorrência de Entrega" isVisible={show} onClose={onModalClose} width={800}>
      <form className="p-grid">
        <div className="p-col-3">
          <InputText
            label="Sigla :"
            marginTop={10}
            value={state.ocorrencia.sigla || ''}
            onChange={value => onFormContentChange('sigla', value)}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="Código Interno :"
            marginTop={10}
            value={state.ocorrencia.company_code || ''}
            onChange={value => onFormContentChange('company_code', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Descrição :"
            marginTop={10}
            value={state.ocorrencia.descricao || ''}
            onChange={value => onFormContentChange('descricao', value)}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 20 }}>
          <CustomCheckbox
            checked={state.ocorrencia.assoc_guilty_client}
            onChange={value => onFormContentChange('assoc_guilty_client', value)}
          >
            Associar cliente responsável pela ocorrência
          </CustomCheckbox>
        </div>
        <div className="p-col-3" style={{ paddingTop: 20 }}>
          <CustomCheckbox
            checked={state.ocorrencia.actived}
            onChange={value => onFormContentChange('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12" style={{ paddingTop: 30 }}>
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalOcorrenciaEntrega)
